import WsService from "../WsService";

const ENDPOINT_BASE = "/authentication/reset-password";

export default class UserService {

  static forgotPassword(username, cellphoneNumber) {

    let endpoint = ENDPOINT_BASE;

    let jsonObj = {};
    jsonObj["username"] = username;
    jsonObj["cellphone-number"] = cellphoneNumber;

    let headers = {
      "Authorization" :""
    };

    return WsService.postWithHeaders(endpoint, jsonObj, 200, headers).then(
      response => {
        return "success";
      },
      response => {
        return response;
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/services/admin/ForgotPasswordService.js